export default "__VITE_ASSET__sCkGniEI__"